import { DEFAULT_LOCALE, DEFAULT_LOCALE_DATA, DEFAULT_TIME_ZONE } from '../../internal/constants';
export default {
    locale: DEFAULT_LOCALE,
    timeZone: DEFAULT_TIME_ZONE,
    localeData: DEFAULT_LOCALE_DATA
};

//# sourceMappingURL=defaultConfig.js.map